import SchoolHub from "@/components/school/SchoolHub";
import { schoolApi } from "@/lib/school";

export default function School() {
  return <div data-testid="school-page"><SchoolHub api={schoolApi} theme="hifz" onlyApp="hifz" /></div>;
}
